(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tide-catch-finder"] && !Shopify.designMode) return;
  try {
    
  const initTideFinders = (root = document) => {
    root.querySelectorAll('[data-tide-finder]').forEach((finder) => {
      if (finder.dataset.ready === 'true') return;
      finder.dataset.ready = 'true';
      const tabs = [...finder.querySelectorAll('[data-tide-tab]')];
      const panels = [...finder.querySelectorAll('[data-tide-panel]')];
      const activate = (tab) => {
        tabs.forEach((item) => {
          const active = item === tab;
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          tabs[next].focus();
          activate(tabs[next]);
        });
      });
    });
  };
  initTideFinders();
  document.addEventListener('shopify:section:load', (event) => initTideFinders(event.target));

  } catch(e) { console.error(e); }
})();
})();
